export default __webpack_public_path__ + "static/media/TractorIcon2.96c10ac4.svg";